import * as levenshtein from 'fast-levenshtein';

export const truncateText = (text: string, maxChar = 20) =>
  text?.length > maxChar ? `${text?.slice(0, maxChar)}...` : text;

export const isLocalizeAdded = (localize, key) =>
  localize(key) && localize(key) !== '' && localize(key) !== key;

export const isDuplicateViolation = (violation: string): boolean => {
  const duplicateViolations = [
    'email',
    'phoneNumber',
    'api_error.user.iban.duplicate',
  ];
  return duplicateViolations.includes(violation);
};

export const correctEmailDomain = (email) => {
  if (!email || typeof email !== 'string') return email;

  const trimmedEmail = email.trim().toLowerCase();
  const atIndex = trimmedEmail.lastIndexOf('@');

  if (atIndex === -1) return email;

  const localPart = trimmedEmail.substring(0, atIndex);
  const domain = trimmedEmail.substring(atIndex + 1);

  // Define specific domain corrections (higher priority)
  const specificCorrections = {
    'cloud.de': 'cloud.com',
    'gmail.de': 'gmail.com',
  };

  // Check for specific corrections first
  if (specificCorrections[domain]) {
    return `${localPart}@${specificCorrections[domain]}`;
  }

  // Define common email domains to check against
  const commonDomains = [
    // International domains
    'gmail.com',
    'hotmail.com',
    'outlook.com',
    'yahoo.com',
    'icloud.com',
    'mail.com',
    'aol.com',
    'protonmail.com',
    'live.com',

    // German-specific domains
    'outlook.de',
    'web.de',
    'gmx.de',
    'gmx.net',
    't-online.de',
    'freenet.de',
    'yahoo.de',

    // Alternative domains
    'googlemail.com',
    'ymail.com',
    'gmx.at',
  ];

  // Calculate distances to all domains
  const distances = commonDomains.map((correctDomain) => ({
    domain: correctDomain,
    distance: levenshtein.get(domain, correctDomain),
  }));

  // Find the minimum distance
  const minDistance = Math.min(...distances.map((d) => d.distance));

  // If minimum distance is >= 3, it's probably not a typo
  if (minDistance >= 3 || domain === 'online.de') return email;

  // Find all domains with the minimum distance
  const closestMatches = distances.filter((d) => d.distance === minDistance);

  // If there's only one closest match, use it
  if (closestMatches.length === 1) {
    return `${localPart}@${closestMatches[0].domain}`;
  }

  // If there are multiple matches with same distance, prefer more common domains
  // The order in commonDomains array represents popularity
  const selectedDomain = closestMatches[0].domain;
  return `${localPart}@${selectedDomain}`;
};
